module.exports = __webpack_public_path__ + "img/cna.2d54bdb5.svg";